<template>
  <div>
    <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

    <div
      style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden"
    >
      <userLeft :active="14" />
      <div class="box5">
        <div class="title">关于我们</div>
        <div style="width: 100%;height: 1px;background: #EDE9E9; margin: 20px 0"></div>
        <div class="biaoti">关于我们</div>
<div class="shijian">发布时间：{{data.releaseTime}}           作者：{{data.author}}</div>
<div class="zhengwen" v-html="data.content" ></div>
</div>
      </div>


    <foot />
  </div>
</template>

<script>
    import axios from "axios";
    import userLeft from "../public/user_left";
    import htmlHeader from "../public/head";
    import foot from "../public/foot";
    export default {
        name: "integral",
        components: {
            userLeft,
            htmlHeader,
            foot,
        },
        data() {
            return {
                data: '',
            }
        },

        methods: {

        },
        created() {
            this.api.get_about_content().then(res => {
                if(res.ok) {
                    this.data = JSON.parse(res.data.description)
                    console.log(this.data);
                }else {
                    this.$message.error(res.message)
                }
            })
        },
    };
</script>

<style scoped>
    .biaoti {
        font-size: 22px;
        text-align: center;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }
    
    .shijian {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        text-align: center;
        margin-top: 20px;
    }
    
    .zhengwen {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        text-align: center;
        margin-top: 40px;
    }
    /deep/.zhengwen table{
        width: 0;
    }
    /deep/ .zhengwen img{
        width: 95%;
    }
    /deep/ .zhengwen p {
        text-align: left;
    }
    .xuanzhong {
        border: 1px solid #2B9A34;
    }
    
    .goods_title {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
    }
    
    .goods_title1 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-top: 10px;
    }
    
    .title {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
    }
    
.box5 {
        min-height: 1023px;
        width: 80%;
        border: 1px solid #ede9e9;
        float: right;
        margin-top: 2%;
        padding: 2%;
    }
    
    .box3 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: Regular;
        color: #666666;
        margin-top: 6%;
    }
    
    .box4 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
    }
    
    .box1 {
        width: 220px;
        min-height: 1023px;
        border: 1px solid #ede9e9;
        float: left;
        margin-top: 2%;
        
    }
    
    .box2 {
        width: 100%;
        height: 45px;
        background: #f2f2f2;
    }
    
    .type_title {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-top: 10px;
        margin-left: 20px;
    }
    
    .type_txt {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999;
        margin-top: 10px;
        margin-left: 20px;
    }
    
    .rich_text_box {
        width: 90%;
        float: left;
        margin-top: 25px;
        margin-left: 2%;
        height: 400px;
        overflow: hidden;
    }
    
    .tijiao {
        width: 100px;
        height: 40px;
        border: 1px solid #2B9A34;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2B9A34;
        margin-left: 40px;
        margin-top: 40px;
        margin-bottom: 40px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/about_us.vue